import { toast, ExternalToast } from "sonner";

/**
 * Utility for Sonner toasts with pre-configured durations.
 */

export const showSuccess = (message: string, options?: ExternalToast) => {
  toast.success(message, {
    duration: 1500,
    ...options,
  });
};

export const showError = (message: string, options?: ExternalToast) => {
  toast.error(message, {
    duration: 2000,
    ...options,
  });
};

export const showInfo = (message: string, options?: ExternalToast) => {
  toast(message, {
    duration: 1500,
    ...options,
  });
};

export const showWarning = (message: string, options?: ExternalToast) => {
  toast.warning(message, {
    duration: 2000,
    ...options,
  });
};
